import { useState, useMemo } from "react";
import type { LabResult } from "@tellescope/ui";
import { useEnduserObservations } from "../../../hooks/useEnduserObservations";
import { useObservationLabResults, useScreeningDates } from "../../../hooks/useObservationLabResults";

export const useVitalDataBlock = () => {
  const { observations, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useEnduserObservations();
  const labResults = useObservationLabResults(observations);
  const screeningDates = useScreeningDates(observations);
  const [selectedResultId, setSelectedResultId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<string | undefined>(undefined);

  const effectiveDate = selectedDate ?? screeningDates[0];

  const selectedResult = useMemo(
    () => (selectedResultId ? labResults.find((r) => r.id === selectedResultId) ?? null : null),
    [selectedResultId, labResults]
  );

  const selectResult = (result: LabResult) => {
    setSelectedResultId(result.id);
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const clearSelection = () => {
    setSelectedResultId(null);
  };

  return {
    labResults,
    selectedResult,
    selectResult,
    clearSelection,
    isLoading,
    error,
    screeningDates,
    selectedDate: effectiveDate,
    setSelectedDate,
  };
};
